exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-search{display:flex;align-items:center;margin-right:15px}.header-search-label{color:#999;cursor:pointer;margin-bottom:0;font-size:18px;width:27px;height:26px}.header-search-label:hover{color:#ccc}.header-search-icon.fa.fa-search{font-size:18px;width:25px;height:25px;margin-right:5px;display:flex;align-items:center}.header-search-input{width:0;display:inline-block;outline:0;border:none;transition:all .3s;caret-color:#ccc}.header-search-input:focus{width:270px;margin-right:5px}.header-search-input:-ms-input-placeholder,.header-search-input::placeholder,.header-search-input:focus:-ms-input-placeholder,.header-search-input:focus::placeholder{color:#ccc!important}.search__input{height:30px!important;display:inline-block!important;border-radius:15px!important;padding-left:30px!important;width:200px!important;transition:width .2s ease-in-out,border-color ease-in-out .15s,box-shadow ease-in-out .15s!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/components/Header/components/PeopleSearcher/style.css
 ** module id = 1639
 ** module chunks = 0
 **/